const COLORS = {
  BASE: '#d1d1db',
  PRIMARY: '#E0061A',
  PRIMARY_BACKGROUND: 'rgb(245, 246, 248)',
  ACCENT: '#000000',
  SECONDARY_MAIN: '#d1d1db',
  WHITE: '#fff',
  LIGHT_GREY: '#efefef',
  GREY: 'rgba(0, 0, 0, 0.54)',
  DARK_GREY: '#2E2E2E',
  BUTTON: '#1A171B',
  FONT: '#1A171B',
  FONT_SECONDARY: '#49454F',
  SUCCESS: '#088F20',
}

export { COLORS }
